<template>
  <div>
    <p class="header-title">
      {{ $t("users.form.activate") }} {{ $t("common.user") }}
    </p>
    <div class="hint-modal">
      {{ $t("common.notes.areYouSureYouWant") }}
      <b>"{{ $t("users.form.activate") }}"</b> {{ userName
      }}{{ $t("common.questionMark") }}
    </div>

    <div class="h-line"></div>

    <div class="btns-cont">
      <button class="submit-action-btn" @click="onConfirmHandler">
        {{ $t("users.form.activate") }}
      </button>
      <button class="cancel-btn" @click="$bvModal.hide(modalId)">
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    userId: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: "User",
    },
    modalId: {
      type: String,
    },
  },
  methods: {
    ...mapActions("users", ["denyUser"]),
    async onConfirmHandler() {
      await this.denyUser([{ user_id: this.userId, active: 1 }]);

      this.$emit("modalConfirmationUpdate");
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
<style lang="scss">
div[id*="activateModal_"] {
  // background: #F3F3F3;
  // padding-inline-end:0px!important;
  // border-radius: 26px;

  div[id*="___BV_modal_content_"] {
    width: 580px;
    margin-top: 180px;
    border-radius: 26px;
  }
  .modal-content .modal-body {
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    .hint-modal {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;

      text-align: center;
      color: #787878;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 488px;
      height: 1px;
      margin: 40px auto 20px auto;
    }
    .btns-cont {
      display: flex;
      align-items: center;
      justify-content: center;
      button.submit-action-btn {
        background: #103f5e;
        width: 111px;
        height: 33px;
        border: none;
        color: #ffffff;

        border-radius: 16px;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin-inline-end: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      button.cancel-btn {
        border: 1.5px solid #f46a6a;
        border-radius: 16.6275px;
        color: #f46a6a;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        width: 111px;
        height: 33px;
        background: #ffffff;
      }
    }
  }
}
</style>
